var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-link', {
    attrs: {
      "href": _vm.source,
      "target": "_blank",
      "relation": "help"
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "notifications_question-circle"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }